import React from 'react';
import { IProps } from './type';

const VisibilityOffIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2378 16.0005C19.0491 15.268 19.7144 14.5264 20.1888 13.9505C20.5769 13.4792 20.771 13.2436 20.771 12.8848C20.771 12.526 20.5769 12.2903 20.1888 11.8191C18.7687 10.0949 15.6365 6.88477 12.0007 6.88477C11.1613 6.88477 10.3486 7.05591 9.57769 7.3404L12.1246 9.88727C13.6829 9.95054 14.935 11.2026 14.9982 12.7609L18.2378 16.0005ZM9.39381 11.3992C9.14368 11.8372 9.00074 12.3443 9.00074 12.8848C9.00074 14.5416 10.3439 15.8848 12.0007 15.8848C12.5412 15.8848 13.0484 15.7418 13.4863 15.4917L15.7879 17.7933C14.6368 18.4403 13.3536 18.8848 12.0007 18.8848C8.36501 18.8848 5.2328 15.6746 3.81271 13.9505C3.42455 13.4792 3.23047 13.2436 3.23047 12.8848C3.23047 12.526 3.42455 12.2903 3.81271 11.8191C4.48614 11.0014 5.54458 9.84966 6.85916 8.86451L9.39381 11.3992Z"
        fill={fillColor ? fillColor : "#B1B2B5"} />
      <path
        d="M5 2.88477L21 18.8848"
        stroke={strokeColor ? strokeColor : "#B1B2B5"}
        strokeWidth="2" />
    </svg>
  )
};

export default VisibilityOffIcon;
